import React from 'react'

import { Box, Typography } from '@mui/material'

import Modal from '../../../../shared/components/Modal/Modal.component'

import { formatMoney } from '../../../../shared/functions/String/string.functions'
import styles from './CustomsLimitError.styles'
import { CustomsLimitErrorModalProps } from './CustomsLimitError.types'

const CustomsLimitErrorModal: React.FC<CustomsLimitErrorModalProps> = ({ open, error, onClose, onAdjustItems }) => {
  if (!error) {
    return null
  }

  const orderTotal = formatMoney(error.totalDeclaredValueCents / 100)
  const customsLimit = formatMoney(error.customsLimitCents / 100)
  const excessAmount = formatMoney((error.totalDeclaredValueCents - error.customsLimitCents) / 100)

  const handleAdjustItems = () => {
    onAdjustItems()
    onClose()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Customs Limit Exceeded"
      icon="error"
      primaryButton={{
        label: 'Adjust Items',
        onClick: handleAdjustItems
      }}
      maxWidth="sm"
      body={
        <Box sx={styles.modalBody}>
          <Typography variant="body1" sx={styles.errorMessage}>
            Your order total of {orderTotal} exceeds the customs limit of {customsLimit} for {error.destinationCountry}.
            Please remove items or reduce declared values to meet customs limits.
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Excess amount: {excessAmount}
          </Typography>

          {error.exceededItems && error.exceededItems.length > 0 && (
            <Box sx={styles.itemsList}>
              <Typography variant="subtitle2" sx={{ marginBottom: 1 }}>
                Items exceeding limit:
              </Typography>
              {error.exceededItems.map((item, index) => (
                <Typography key={index} variant="body2" sx={styles.itemText}>
                  • {item}
                </Typography>
              ))}
            </Box>
          )}
        </Box>
      }
    />
  )
}

export default CustomsLimitErrorModal
